import React from 'react';
import Plus from '@uber/base-icons/plus';
import type { Theme } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { useAtomValue } from 'jotai';
import type { RelationshipT } from '../../../../../modernization-common/relationships';
import { RELATIONSHIP_CREATOR_CONSTANTS } from '../../../../../modernization-common/relationships/constants';
import { hasValidationErrorsAtom, isEditingAtom, resolvedRelationshipsAtom } from '../../../atoms/relationship-atoms';
type ActionSectionProps = {
  onSave: (relationships: RelationshipT[]) => void;
  onCancel: () => void;
};
const ACTION_BUTTON_OVERRIDES = {
  BaseButton: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      height: $theme.sizing.scale900,
      borderRadius: $theme.borders.radius300,
      boxSizing: 'border-box'
    })
  }
};
export const ActionSection = ({
  onSave,
  onCancel
}: ActionSectionProps) => {
  const isEditing = useAtomValue(isEditingAtom);
  const output = useAtomValue(resolvedRelationshipsAtom);
  const hasValidationErrors = useAtomValue(hasValidationErrorsAtom);
  const canSave = output.length > 0 && !hasValidationErrors;
  return <>
      <Button kind={BUTTON_KIND.tertiary} size={BUTTON_SIZE.xSmall} onClick={onCancel} overrides={ACTION_BUTTON_OVERRIDES}>
        {RELATIONSHIP_CREATOR_CONSTANTS.CANCEL_BUTTON}
      </Button>
      <Button kind={BUTTON_KIND.primary} size={BUTTON_SIZE.xSmall} endEnhancer={<Plus size={12} />} disabled={!canSave} onClick={() => canSave && onSave(output)} overrides={ACTION_BUTTON_OVERRIDES}>
        {isEditing ? RELATIONSHIP_CREATOR_CONSTANTS.SAVE_BUTTON : RELATIONSHIP_CREATOR_CONSTANTS.CREATE_BUTTON}
      </Button>
    </>;
};